import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import iosIcon from "../common/icons/ios-action.png";
import { useTranslation } from "react-i18next";

import { useIosInstallPrompt } from "./iOSPrompt";
import { useWebInstallPrompt } from "./otherBrowsers";

export const InstallPWA = () => {
  const [iosInstallPrompt, handleIOSInstallDeclined] = useIosInstallPrompt();
  const [webInstallPrompt, handleWebInstallDeclined, handleWebInstallAccepted] =
    useWebInstallPrompt();
  const { t } = useTranslation();

  if (!iosInstallPrompt && !webInstallPrompt) {
    return null;
  }
  return (
    <Dialog open>
      <DialogContent>
        <DialogTitle>
          <Typography align="center">
            {t("Do you want to attach Curves to the home screen? ")}
          </Typography>
        </DialogTitle>
        {iosInstallPrompt && (
          <Typography variant="h4" align="center">
            {t("Press")} <img src={iosIcon} alt="iosIcon" />{" "}
            {t('and select "Add on the home screen".')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color={iosInstallPrompt ? "primary" : "secondary"}
          variant={iosInstallPrompt ? "contained" : "text"}
          fullWidth
          size="large"
          onClick={
            webInstallPrompt
              ? handleWebInstallDeclined
              : handleIOSInstallDeclined
          }
        >
          {t("Not now")}
        </Button>
        {webInstallPrompt && (
          <Button
            color="primary"
            fullWidth
            size="large"
            variant="contained"
            onClick={
              webInstallPrompt
                ? handleWebInstallAccepted
                : handleIOSInstallDeclined
            }
          >
            {t("Install")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
